import Backbone from "backbone";
import PerfectScrollbar from "perfect-scrollbar";
import $ from "jquery";
import SharedDispatcher from "../../common/others/SharedDispatcher";

  export default Backbone.View.extend({

    selectors: {
      orderScroll: ".js-OrderScroll",
    },

    initialize: function () {
      this.listenTo(SharedDispatcher, "expandView:show", this.updateHorizontalScrollbar);
    },

    updateHorizontalScrollbar: function () {
      var that = this;
      var orderScroll = $(this.selectors.orderScroll);

      if (orderScroll.length) {

        orderScroll.each(function () {
          // TODO : use orderScrollbar.destroy() is better than this test 
          if (!$(this).hasClass("ps")) {
            that.orderScrollbar = new PerfectScrollbar(this, {
              suppressScrollY: true,
              useBothWheelAxes: true,
              wheelPropagation: true
            });
          }
        });
      }
    },

  });
